import * as types from 'actions/actionTypes';
import * as services from 'services/apis/jasper/jasperReportService';
import {beginAjaxCall, ajaxCallError} from './ajaxStatusActions';
import * as cookieServices from 'services/cookies/cookieServices';

export function LoginRequest(){
    return {type: types.JASPER_LOGIN_REQUEST}
}

export function LoginSuccess(){
    return {type: types.JASPER_LOGIN_SUCCESS }
}

export function LoginError(){
    return {type: types.JASPER_LOGIN_ERROR}
}

/**
 * eseguo login su Jasper reports
 */
export function Login(){
    return dispatch => {
        /*
            notifico che sta partendo la richiesta
        */
        dispatch(LoginRequest());
        dispatch(beginAjaxCall());

        var sessionId = services.createSessionId();

        // restituisce una promise
        return services.registerToken(sessionId)

            .then(response => {
                cookieServices.saveJasperSessionId(sessionId);
                dispatch(LoginSuccess());
            })
            .catch(error => {
                dispatch(ajaxCallError(error));
                dispatch(LoginError());
        });
    }
}

export function GetOptionsRequest(){
    return {type: types.JASPER_OPTIONS_REQUEST}
}

export function GetOptionsSuccess(data){
    return {type: types.JASPER_OPTIONS_SUCCESS, data }
}

export function GetOptionsError(){
    return {type: types.JASPER_OPTIONS_ERROR}
}

export function GetOptions(accountId){
    return dispatch => {
        /*
            notifico che sta partendo la richiesta
        */
        dispatch(GetOptionsRequest());
        dispatch(beginAjaxCall());

        // restituisce una promise
        return services.getJasperOptions(accountId)

            .then(response => {
                console.info(response.data.results);
                dispatch(GetOptionsSuccess(response.data.results));
            })
            .catch(error => {
                dispatch(ajaxCallError(error));
                dispatch(GetOptionsError());
        });
    }
}

export function LoadReportRequest(){
    return {type: types.JASPER_LOADREPORT_REQUEST}
}

export function LoadReportSuccess(){
    return {type: types.JASPER_OPTIONS_SUCCESS }
}

export function LoadReportError(){
    return {type: types.JASPER_OPTIONS_ERROR}
}

/**
 * esegue login + chiamate ad getoptions
 */
export const LoadReport = (accountId) => dispatch => {
    /*
        notifico che sta partendo la richiesta
    */

    dispatch(Login()).then(() => {
        console.log("0 - jasper - login completed");

        dispatch(GetOptions(accountId)).then(() => {
            console.log("1 - jasper - get options completed");
        });
    });

}


// WEBPACK FOOTER //
// ./src/actions/jasperServicesActions.js